import { Icons } from '../../components/atoms/Icon'
import { CheeseMainContentProps } from '../../components/molecules/CheeseMainContent'
import { Cheese } from '../../graphql/generated/api-graphql'
import { wediaImagesTransform } from '../Common/wedia'

const cheeseMainContentTransformer = (
  t: any,
  data: Cheese
): CheeseMainContentProps => {
  return {
    traits: [
      ...(data.tagMilk?.name
        ? [
            {
              icon: Icons.milk,
              label: data.tagMilk.name,
            },
          ]
        : []),
      ...(data.tagRegion?.name
        ? [
            {
              icon: Icons.location,
              label: data.tagRegion.name,
            },
          ]
        : []),
      ...(data.tagType?.name
        ? [
            {
              icon: Icons.cheese,
              label: data.tagType.name,
            },
          ]
        : []),
      ...(data.tagIntensity?.name
        ? [
            {
              icon: Icons.level,
              label: data.tagIntensity.name,
            },
          ]
        : []),
    ],
    characterTitle: data?.history ? t('character') : undefined,
    characterText: data?.history ?? undefined,
    characterImage: {
      maxWidth: 300,
      width: 288,
      height: 216,
      withHD: true,
      images: data.thumbnail01
        ? wediaImagesTransform(data.thumbnail02)
        : undefined,
      alt: data.thumbnail01?.alt ?? '',
    },
    didYouKnowTitle: data.dyk ? t('did_you_know') : undefined,
    didYouKnowText: data.dyk ?? undefined,
    originTitle: data.origin ? t('origin') : undefined,
    originText: data.origin ?? undefined,
    originImage: {
      maxWidth: 300,
      width: 288,
      height: 288,
      withHD: true,
      alt: data.pictureMap?.alt ?? '',
      images: data.pictureMap
        ? wediaImagesTransform(data.pictureMap)
        : undefined,
    },
    healthTitle: data.health ? t('health') : undefined,
    healthText: data.health ?? undefined,
    tastingTitle: data.taste ? t('degustation') : undefined,
    tastingText: data.taste ?? undefined,
    bestWithTitle:
      data.tasteWineBody || data.tasteBreadBody
        ? t('even_better_with')
        : undefined,
    bestWithEntries: [
      ...(data.tasteWineBody
        ? [
            {
              icon: Icons.wineGlass,
              title: data.tasteWineTitle ?? '',
              text: data.tasteWineBody,
            },
          ]
        : []),
      ...(data.tasteBreadBody
        ? [
            {
              icon: Icons.bread,
              title: data.tasteBreadTitle ?? '',
              text: data.tasteBreadBody,
            },
          ]
        : []),
    ],
  }
}

export default cheeseMainContentTransformer
